export default __webpack_public_path__ + "static/media/Metamask-fox.d4e89c6c.svg";